import React from 'react';
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

import { IconWrapper } from 'components/Icon';

const Description = ({ name, description }) => (
  <Tooltip title={description}>
    <Stack aria-label={`Description of ${name}`}>
      <IconWrapper
        icon="info"
        height={16}
        display="flex"
        sx={({ palette }) => ({
          display: 'flex',
          svg: { width: 16, height: 16, color: palette.grey[500] },
        })}
      />
    </Stack>
  </Tooltip>
);

export const RoleLevelMatrix = ({ structure, roles, label, renderCell, showDescriptions }) => {
  const levels = [...structure.levels].reverse();

  return (
    <Box
      role="table"
      aria-label={label}
      sx={({ palette }) => ({
        display: 'grid',
        gridTemplateColumns: `minmax(164px, max-content) repeat(${levels.length}, minmax(112px, max-content)) 1fr`,
        alignItems: 'stretch',
        minWidth: 'fit-content',
        '& [role="row"]:nth-of-type(2n+3) > *': {
          bgcolor: alpha(palette.primary.main, 0.05),
        },
      })}
    >
      <Box role="row" display="contents">
        <Box role="columnheader" />
        {levels.map(({ level_id, name, description }) => (
          <Stack
            key={level_id}
            role="columnheader"
            direction="row"
            alignItems="center"
            justifyContent="center"
            gap={0.5}
            px={1}
            py={1}
          >
            <Typography variant="body2" fontWeight={700}>
              {name}
            </Typography>
            {showDescriptions && description && (
              <Description name={name} description={description} />
            )}
          </Stack>
        ))}
        <Box aria-hidden />
      </Box>
      {roles.map((role) => (
        <Box key={role.role_id} role="row" display="contents">
          <Stack role="rowheader" direction="row" alignItems="center" gap={0.5} pl={3} pr={2}>
            <Typography variant="body2" fontWeight={700}>
              {role.name}
            </Typography>
            {showDescriptions && role.description && (
              <Description name={role.name} description={role.description} />
            )}
          </Stack>
          {levels.map((level) => (
            <Stack key={level.level_id} role="cell" alignItems="center" justifyContent="center">
              {renderCell(role, level)}
            </Stack>
          ))}
          <Box aria-hidden />
        </Box>
      ))}
    </Box>
  );
};
